import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ToastService } from '../shared-new/services/toast.service';

@Component({
  selector: 'forgot-password-page',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  public fogotPasswordForm: FormGroup;
  public isLoader = false;
  public responseError: any;

  public constructor(
    private readonly formBuilder: FormBuilder,
    private readonly authService: AuthService,
    private router: Router,
    private toastService: ToastService
  ) {}

  public submitForm(formData: { username: string }): void {
    if (formData && formData.username) {
      this.isLoader = true;
      this.authService.forgotPasswordByUserName(formData.username).subscribe(
        (response) => {
          if (response) {
            this.toastService.success(
              "We've sent an email to the address associated with your account."
            );
            this.router.navigateByUrl('/login');
          }
          this.isLoader = false;
        },
        (errorResponse: Error) => {
          const errorData = JSON.parse(JSON.stringify(errorResponse));
          if (errorData?.error) {
            if (
              errorData?.status === 400 ||
              errorData?.status === 401 ||
              errorData?.status === 403
            ) {
              if (errorData?.error[0]) {
                this.responseError = errorData?.error[0].message;
                this.toastService.error(this.responseError);
              }
            }
          }
          this.isLoader = false;
        }
      );
    }
  }

  public ngOnInit(): void {
    this.fogotPasswordForm = this.formBuilder.group({
      username: ['', [Validators.required]],
    });
  }
}
